// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface removeOnlineCourseFromCartRequestPayload {
  id: number;
  callback: Function;
}
export interface removeOnlineCourseFromCartSuccessPayload {}

export interface removeOnlineCourseFromCartFailPayload {
  error: Error;
}

export const removeOnlineCourseFromCartActions = createAsyncAction(
  'elearning/REMOVE_ONLINE_COURSE_FROM_CART',
  'elearning/REMOVE_ONLINE_COURSE_FROM_CART_SUCCESS',
  'elearning/REMOVE_ONLINE_COURSE_FROM_CART_FAIL'
)<
  removeOnlineCourseFromCartRequestPayload,
  removeOnlineCourseFromCartSuccessPayload,
  removeOnlineCourseFromCartFailPayload
>();
